import { render } from "./BibleVerse.vue?vue&type=template&id=3aae3e10&scoped=true"
import script from "./BibleVerse.vue?vue&type=script&lang=js"
export * from "./BibleVerse.vue?vue&type=script&lang=js"

import "./BibleVerse.vue?vue&type=style&index=0&id=3aae3e10&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3aae3e10"]])

export default __exports__